<div class="container-fluid mt-3 h-100">

  <!-- <div class="row mb-3">
    <div class="col-md-6">
      <div class="card p-3 shadow-sm h-100">
        <h6 class="card-title">Enter Location</h6>
        <input type="text" class="form-control" placeholder="Enter a location" #locationInput
          (keyup.enter)="addLocation(locationInput.value); locationInput.value='';"
          (focus)="initAutocomplete(locationInput)" />
        <small class="form-text text-muted mt-1">
          Press Enter to add location
        </small>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card p-3 shadow-sm h-100">
        <h6 class="card-title">Entered Locations</h6>
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center"
            *ngFor="let loc of stops; let i = index">
            {{ loc }}
            <button class="btn btn-sm btn-outline-danger" (click)="removeLocation(i)">
              &times;
            </button>
          </li>
        </ul>
        <button class="btn btn-primary w-100 mt-2" (click)="generateRoute()">
          Generate Route
        </button>
      </div>
    </div>
  </div> -->

  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="card shadow-sm h-100">
        <div id="map" style="height: 100%; width: 100%; border-radius: 0.5rem;"></div>
      </div>
    </div>
  </div>
</div>